













































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import TreeSelect from "@riophae/vue-treeselect";
import PricePo from "@/store/entities/finance/pricepo";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
class pricedetailpo {
  name: string;
  dailyprice: number; //日常基础价格
  daylyserviceprice: number; //日常服务价格
  sewageprice: number; //排污价格
  summerprice: number; //夏季基础价格
  summerserviceprice: number; //夏季服务价格
  num: number; //阶梯量
}

@Component({
  components: { TreeSelect },
})
export default class CreatePrice extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: "1" }) iteminfo: string;
  pricepo: PricePo = new PricePo();
  isAble: boolean = true;
  columns: any[] = [];
  columnsdata: any[] = [];
  pricedetailpo = new pricedetailpo();

  async created() {
    this.meterTypeDetail();
    await this.areaTree();
    this.addfiexd(null);
    this.columns = this.columnlist;
    this.pricepo.unitNum = 1;
    this.pricepo.isEnable = 1;
    this.pricepo.priceType = 0;
    this.pricepo.cycle = 0;
    this.pricepo.firstNum = 1;
    this.pricepo.firstBasePrice = 1;
    this.pricepo.firstSewagePrice = 0;
    this.pricepo.firstSyntheticalPrice = 0;
    this.pricepo.secondNum = 0;
    this.pricepo.secondBasePrice = 0;
    this.pricepo.secondSewagePrice = 0;
    this.pricepo.secondSyntheticalPrice = 0;
    this.pricepo.thirdNum = 0;
    this.pricepo.thirdBasePrice = 0;
    this.pricepo.thirdSewagePrice = 0;
    this.pricepo.thirdSyntheticalPrice = 0;
    this.pricepo.fourNum = 0;
    this.pricepo.fourBasePrice = 0;
    this.pricepo.fourSewagePrice = 0;
    this.pricepo.fourSyntheticalPrice = 0;
    this.pricepo.establishmentFee = 0;
    this.pricepo.isEnable = 1;
    this.pricepo.isSummer = false;
    this.pricepo.summerFirstPrice = 0;
    this.pricepo.summerSecondPrice = 0;
    this.pricepo.summerThirdPrice = 0;
    this.pricepo.summerFourPrice = 0;
    this.pricepo.summerFirstServicePrice = 0;
    this.pricepo.summerSecondServicePrice = 0;
    this.pricepo.summerThirdServicePrice = 0;
    this.pricepo.summerFourServicePrice = 0;
    this.pricepo.settlementStandard = 1;
    this.pricepo.meterType = this.$data.meterTypedetail[0].value;
    this.pricepo.basePrice = 0;
  }
  //添加尖峰平谷
  addPeakPinggu(data: any[]) {
    this.columnsdata = [];
    if (data == null || data.length == 0) {
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("Tip");
      this.pricedetailpo.dailyprice = 0;
      this.pricedetailpo.daylyserviceprice = 0;
      this.pricedetailpo.summerprice = 0;
      this.pricedetailpo.summerserviceprice = 0;
      this.pricedetailpo.sewageprice = 0;
      this.columnsdata.push(this.pricedetailpo);
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("Peak");
      this.pricedetailpo.dailyprice = 0;
      this.pricedetailpo.daylyserviceprice = 0;
      this.pricedetailpo.summerprice = 0;
      this.pricedetailpo.summerserviceprice = 0;
      this.pricedetailpo.sewageprice = 0;
      this.columnsdata.push(this.pricedetailpo);
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("Flat");
      this.pricedetailpo.dailyprice = 0;
      this.pricedetailpo.daylyserviceprice = 0;
      this.pricedetailpo.summerprice = 0;
      this.pricedetailpo.summerserviceprice = 0;
      this.pricedetailpo.sewageprice = 0;
      this.columnsdata.push(this.pricedetailpo);
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("Valley");
      this.pricedetailpo.dailyprice = 0;
      this.pricedetailpo.daylyserviceprice = 0;
      this.pricedetailpo.summerprice = 0;
      this.pricedetailpo.summerserviceprice = 0;
      this.pricedetailpo.sewageprice = 0;
      this.columnsdata.push(this.pricedetailpo);
    }
  }
  //添加固定单价
  addfiexd(data: any[]) {
    this.columnsdata = [];
    if (data == null || data.length == 0) {
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("FixedPrice");
      this.pricedetailpo.dailyprice = 0;
      this.pricedetailpo.daylyserviceprice = 0;
      this.pricedetailpo.summerprice = 0;
      this.pricedetailpo.summerserviceprice = 0;
      this.pricedetailpo.sewageprice = 0;
      this.columnsdata.push(this.pricedetailpo);
    }
  }
  //添加阶梯单价
  addstepprice(data: any[]) {
    this.columnsdata = [];
    if (data == null || data.length == 0) {
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("FirstStep");
      this.pricedetailpo.dailyprice = 0;
      this.pricedetailpo.daylyserviceprice = 0;
      this.pricedetailpo.num = 0;
      this.pricedetailpo.summerprice = 0;
      this.pricedetailpo.summerserviceprice = 0;
      this.pricedetailpo.sewageprice = 0;
      this.columnsdata.push(this.pricedetailpo);
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("SecondStep");
      this.pricedetailpo.dailyprice = 0;
      this.pricedetailpo.daylyserviceprice = 0;
      this.pricedetailpo.num = 0;
      this.pricedetailpo.summerprice = 0;
      this.pricedetailpo.summerserviceprice = 0;
      this.pricedetailpo.sewageprice = 0;
      this.columnsdata.push(this.pricedetailpo);
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("ThirdStep");
      this.pricedetailpo.dailyprice = 0;
      this.pricedetailpo.daylyserviceprice = 0;
      this.pricedetailpo.num = 0;
      this.pricedetailpo.summerprice = 0;
      this.pricedetailpo.summerserviceprice = 0;
      this.pricedetailpo.sewageprice = 0;
      this.columnsdata.push(this.pricedetailpo);
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("FourStep");
      this.pricedetailpo.dailyprice = 0;
      this.pricedetailpo.daylyserviceprice = 0;
      this.pricedetailpo.num = 0;
      this.pricedetailpo.summerprice = 0;
      this.pricedetailpo.summerserviceprice = 0;
      this.pricedetailpo.sewageprice = 0;
      this.columnsdata.push(this.pricedetailpo);
    }
  }
  //正常列
  columnlist = [
    {
      title: this.L("Name"),
      key: "name",
    },
    {
      title: this.L("Daily"),
      align: "center",
      children: [
        {
          title: this.L("Daily"),
          key: "dailyprice",
          render: (h: any, params: any) => {
            let self = this;
            return h("Input", {
              props: {
                value: params.row.dailyprice,
              },
              domProps: {
                value: params.row.dailyprice,
              },
              on: {
                input: function (event) {
                  const index = params.index;
                  if (self.pricepo.priceType == 0) {
                    //固定
                    self.pricepo.firstBasePrice = event;
                  } else if (self.pricepo.priceType == 1) {
                    //尖峰平谷
                    if (index == 0) {
                      self.pricepo.secondBasePrice = event;
                    } else if (index == 1) {
                      self.pricepo.thirdBasePrice = event;
                    } else if (index == 2) {
                      self.pricepo.firstBasePrice = event;
                    } else if (index == 3) {
                      self.pricepo.fourBasePrice = event;
                    }
                  } else if (self.pricepo.priceType == 2) {
                    //阶梯
                    if (index == 0) {
                      self.pricepo.firstBasePrice = event;
                    } else if (index == 1) {
                      self.pricepo.secondBasePrice = event;
                    } else if (index == 2) {
                      self.pricepo.thirdBasePrice = event;
                    } else if (index == 3) {
                      self.pricepo.fourBasePrice = event;
                    }
                  }
                },
              },
            });
          },
        },
        {
          title: this.L("ServiceCharge"),
          key: "daylyserviceprice",
          render: (h: any, params: any) => {
            let self = this;
            return h("Input", {
              props: {
                value: params.row.daylyserviceprice,
              },
              domProps: {
                value: params.row.daylyserviceprice,
              },
              on: {
                input: function (event) {
                  const index = params.index;
                  if (self.pricepo.priceType == 0) {
                    self.pricepo.firstSyntheticalPrice = event;
                  } else if (self.pricepo.priceType == 1) {
                    //尖峰平谷
                    if (index == 0) {
                      self.pricepo.secondSyntheticalPrice = event;
                    } else if (index == 1) {
                      self.pricepo.thirdSyntheticalPrice = event;
                    } else if (index == 2) {
                      self.pricepo.firstSyntheticalPrice = event;
                    } else if (index == 3) {
                      self.pricepo.fourSyntheticalPrice = event;
                    }
                  } else if (self.pricepo.priceType == 2) {
                    //阶梯
                    if (index == 0) {
                      self.pricepo.firstSyntheticalPrice = event;
                    } else if (index == 1) {
                      self.pricepo.secondSyntheticalPrice = event;
                    } else if (index == 2) {
                      self.pricepo.thirdSyntheticalPrice = event;
                    } else if (index == 3) {
                      self.pricepo.fourSyntheticalPrice = event;
                    }
                  }
                },
              },
            });
          },
        },
      ],
    },
    {
      title: this.L("SummerPrice"),
      align: "center",
      children: [
        {
          title: this.L("SummerPrice"),
          key: "summerprice",
          render: (h: any, params: any) => {
            let self = this;
            return h("Input", {
              props: {
                value: params.row.summerprice,
              },
              domProps: {
                value: params.row.summerprice,
              },
              on: {
                input: function (event) {
                  const index = params.index;
                  if (self.pricepo.priceType == 0) {
                    //固定单价
                    self.pricepo.summerFirstPrice = event;
                  } else if (self.pricepo.priceType == 1) {
                    //尖峰平谷
                    if (index == 0) {
                      self.pricepo.summerSecondPrice = event;
                    } else if (index == 1) {
                      self.pricepo.summerThirdPrice = event;
                    } else if (index == 2) {
                      self.pricepo.summerFirstPrice = event;
                    } else if (index == 3) {
                      self.pricepo.summerFourPrice = event;
                    }
                  } else if (self.pricepo.priceType == 2) {
                    //阶梯价
                    if (index == 0) {
                      self.pricepo.summerFirstPrice = event;
                    } else if (index == 1) {
                      self.pricepo.summerSecondPrice = event;
                    } else if (index == 2) {
                      self.pricepo.summerThirdPrice = event;
                    } else if (index == 3) {
                      self.pricepo.summerFourPrice = event;
                    }
                  }
                },
              },
            });
          },
        },
        {
          title: this.L("ServiceCharge"),
          key: "summerserviceprice",
          render: (h: any, params: any) => {
            let self = this;
            return h("Input", {
              props: {
                value: params.row.summerserviceprice,
              },
              domProps: {
                value: params.row.summerserviceprice,
              },
              on: {
                input: function (event) {
                  const index = params.index;
                  if (self.pricepo.priceType == 0) {
                    //固定夏季
                    self.pricepo.summerFirstServicePrice = event;
                  } else if (self.pricepo.priceType == 1) {
                    //尖峰平谷夏季服务
                    if (index == 0) {
                      self.pricepo.summerSecondServicePrice = event;
                    } else if (index == 1) {
                      self.pricepo.summerThirdServicePrice = event;
                    } else if (index == 2) {
                      self.pricepo.summerFirstServicePrice = event;
                    } else if (index == 3) {
                      self.pricepo.summerFourServicePrice = event;
                    }
                  } else if (self.pricepo.priceType == 2) {
                    //阶梯夏季服务
                    if (index == 0) {
                      self.pricepo.summerFirstServicePrice = event;
                    } else if (index == 1) {
                      self.pricepo.summerSecondServicePrice = event;
                    } else if (index == 2) {
                      self.pricepo.summerThirdServicePrice = event;
                    } else if (index == 3) {
                      self.pricepo.summerFourServicePrice = event;
                    }
                  }
                },
              },
            });
          },
        },
      ],
    },
  ];
  //水表列
  watercolumnslist = [
    {
      title: this.L("Name"),
      key: "name",
    },
    {
      title: this.L("Daily"),
      key: "dailyprice",
      render: (h: any, params: any) => {
        let self = this;
        return h("Input", {
          props: {
            value: params.row.dailyprice,
          },
          domProps: {
            value: params.row.dailyprice,
          },
          on: {
            input: function (event) {
              const index = params.index;
              if (self.pricepo.priceType == 0) {
                //固定
                self.pricepo.firstBasePrice = event;
              } else if (self.pricepo.priceType == 2) {
                //阶梯
                if (index == 0) {
                  self.pricepo.firstBasePrice = event;
                } else if (index == 1) {
                  self.pricepo.secondBasePrice = event;
                } else if (index == 2) {
                  self.pricepo.thirdBasePrice = event;
                } else if (index == 3) {
                  self.pricepo.fourBasePrice = event;
                }
              }
            },
          },
        });
      },
    },
    {
      title: this.L("SewagePrice"),
      key: "sewageprice",
      render: (h: any, params: any) => {
        let self = this;
        return h("Input", {
          props: {
            value: params.row.sewageprice,
          },
          domProps: {
            value: params.row.sewageprice,
          },
          on: {
            input: function (event) {
              const index = params.index;
              if (self.pricepo.priceType == 0) {
                //固定
                self.pricepo.firstSewagePrice = event;
              } else if (self.pricepo.priceType == 2) {
                //阶梯
                if (index == 0) {
                  self.pricepo.firstSewagePrice = event;
                } else if (index == 1) {
                  self.pricepo.secondSewagePrice = event;
                } else if (index == 2) {
                  self.pricepo.thirdSewagePrice = event;
                } else if (index == 3) {
                  self.pricepo.fourSewagePrice = event;
                }
              }
            },
          },
        });
      },
    },
    {
      title: this.L("ServiceCharge"),
      key: "daylyserviceprice",
      render: (h: any, params: any) => {
        let self = this;
        return h("Input", {
          props: {
            value: params.row.daylyserviceprice,
          },
          domProps: {
            value: params.row.daylyserviceprice,
          },
          on: {
            input: function (event) {
              const index = params.index;
              if (self.pricepo.priceType == 0) {
                //固定
                self.pricepo.firstSyntheticalPrice = event;
              } else if (self.pricepo.priceType == 2) {
                //阶梯
                if (index == 0) {
                  self.pricepo.firstSyntheticalPrice = event;
                } else if (index == 1) {
                  self.pricepo.secondSyntheticalPrice = event;
                } else if (index == 2) {
                  self.pricepo.thirdSyntheticalPrice = event;
                } else if (index == 3) {
                  self.pricepo.fourSyntheticalPrice = event;
                }
              }
            },
          },
        });
      },
    },
  ];
  //阶梯
  stepcolumnlist = [
    {
      title: this.L("Name"),
      key: "name",
    },
    {
      title: this.L("StepNum"),
      key: "num",
      render: (h: any, params: any) => {
        let self = this;
        return h("Input", {
          props: {
            value: params.row.num,
          },
          domProps: {
            value: params.row.num,
          },
          on: {
            input: function (event) {
              const index = params.index;
              if (self.pricepo.priceType == 2) {
                //阶梯
                if (index == 0) {
                  self.pricepo.firstNum = event;
                } else if (index == 1) {
                  self.pricepo.secondNum = event;
                } else if (index == 2) {
                  self.pricepo.thirdNum = event;
                } else if (index == 3) {
                  self.pricepo.fourNum = event;
                }
              }
            },
          },
        });
      },
    },
    {
      title: this.L("Daily"),
      align: "center",
      children: [
        {
          title: this.L("Daily"),
          key: "dailyprice",
          render: (h: any, params: any) => {
            let self = this;
            return h("Input", {
              props: {
                value: params.row.dailyprice,
              },
              domProps: {
                value: params.row.dailyprice,
              },
              on: {
                input: function (event) {
                  const index = params.index;
                  if (self.pricepo.priceType == 0) {
                    //固定
                    self.pricepo.firstBasePrice = event;
                  } else if (self.pricepo.priceType == 1) {
                    //尖峰平谷
                    if (index == 0) {
                      self.pricepo.secondBasePrice = event;
                    } else if (index == 1) {
                      self.pricepo.thirdBasePrice = event;
                    } else if (index == 2) {
                      self.pricepo.firstBasePrice = event;
                    } else if (index == 3) {
                      self.pricepo.fourBasePrice = event;
                    }
                  } else if (self.pricepo.priceType == 2) {
                    //阶梯
                    if (index == 0) {
                      self.pricepo.firstBasePrice = event;
                    } else if (index == 1) {
                      self.pricepo.secondBasePrice = event;
                    } else if (index == 2) {
                      self.pricepo.thirdBasePrice = event;
                    } else if (index == 3) {
                      self.pricepo.fourBasePrice = event;
                    }
                  }
                },
              },
            });
          },
        },
        {
          title: this.L("ServiceCharge"),
          key: "daylyserviceprice",
          render: (h: any, params: any) => {
            let self = this;
            return h("Input", {
              props: {
                value: params.row.daylyserviceprice,
              },
              domProps: {
                value: params.row.daylyserviceprice,
              },
              on: {
                input: function (event) {
                  const index = params.index;
                  if (self.pricepo.priceType == 0) {
                    self.pricepo.firstSyntheticalPrice = event;
                  } else if (self.pricepo.priceType == 1) {
                    //尖峰平谷
                    if (index == 0) {
                      self.pricepo.secondSyntheticalPrice = event;
                    } else if (index == 1) {
                      self.pricepo.thirdSyntheticalPrice = event;
                    } else if (index == 2) {
                      self.pricepo.firstSyntheticalPrice = event;
                    } else if (index == 3) {
                      self.pricepo.fourSyntheticalPrice = event;
                    }
                  } else if (self.pricepo.priceType == 2) {
                    //阶梯
                    if (index == 0) {
                      self.pricepo.firstSyntheticalPrice = event;
                    } else if (index == 1) {
                      self.pricepo.secondSyntheticalPrice = event;
                    } else if (index == 2) {
                      self.pricepo.thirdSyntheticalPrice = event;
                    } else if (index == 3) {
                      self.pricepo.fourSyntheticalPrice = event;
                    }
                  }
                },
              },
            });
          },
        },
      ],
    },
    {
      title: this.L("SummerPrice"),
      align: "center",
      children: [
        {
          title: this.L("SummerPrice"),
          key: "summerprice",
          render: (h: any, params: any) => {
            let self = this;
            return h("Input", {
              props: {
                value: params.row.summerprice,
              },
              domProps: {
                value: params.row.summerprice,
              },
              on: {
                input: function (event) {
                  const index = params.index;
                  if (self.pricepo.priceType == 0) {
                    //固定单价
                    self.pricepo.summerFirstPrice = event;
                  } else if (self.pricepo.priceType == 1) {
                    //尖峰平谷
                    if (index == 0) {
                      self.pricepo.summerFirstPrice = event;
                    } else if (index == 1) {
                      self.pricepo.summerSecondPrice = event;
                    } else if (index == 2) {
                      self.pricepo.summerThirdPrice = event;
                    } else if (index == 3) {
                      self.pricepo.summerFourPrice = event;
                    }
                  } else if (self.pricepo.priceType == 2) {
                    //阶梯价
                    if (index == 0) {
                      self.pricepo.summerFirstPrice = event;
                    } else if (index == 1) {
                      self.pricepo.summerSecondPrice = event;
                    } else if (index == 2) {
                      self.pricepo.summerThirdPrice = event;
                    } else if (index == 3) {
                      self.pricepo.summerFourPrice = event;
                    }
                  }
                },
              },
            });
          },
        },
        {
          title: this.L("ServiceCharge"),
          key: "summerserviceprice",
          render: (h: any, params: any) => {
            let self = this;
            return h("Input", {
              props: {
                value: params.row.summerserviceprice,
              },
              domProps: {
                value: params.row.summerserviceprice,
              },
              on: {
                input: function (event) {
                  const index = params.index;
                  if (self.pricepo.priceType == 0) {
                    //固定夏季
                    self.pricepo.summerFirstServicePrice = event;
                  } else if (self.pricepo.priceType == 1) {
                    //尖峰平谷夏季服务
                    if (index == 0) {
                      self.pricepo.summerSecondServicePrice = event;
                    } else if (index == 1) {
                      self.pricepo.summerThirdServicePrice = event;
                    } else if (index == 2) {
                      self.pricepo.summerFirstServicePrice = event;
                    } else if (index == 3) {
                      self.pricepo.summerFourServicePrice = event;
                    }
                  } else if (self.pricepo.priceType == 2) {
                    //阶梯夏季服务
                    if (index == 0) {
                      self.pricepo.summerFirstServicePrice = event;
                    } else if (index == 1) {
                      self.pricepo.summerSecondServicePrice = event;
                    } else if (index == 2) {
                      self.pricepo.summerThirdServicePrice = event;
                    } else if (index == 3) {
                      self.pricepo.summerFourServicePrice = event;
                    }
                  }
                },
              },
            });
          },
        },
      ],
    },
  ];
  //修改表计类型
  changeMeterType(val: any) {
    //水表
    if (val == 22) {
      this.columns = this.watercolumnslist; //改成水表表格
      this.addfiexd(null);
      this.pricepo.priceType = 0;
    } else {
      this.columns = this.columnlist; //改成常用表格
      this.pricepo.priceType = 0;
      this.addfiexd(null);
    }
  }
  //修改价格类型改变
  changeDisplay(val: any) {
    if (this.pricepo.meterType == 22 && val == 1) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("WaterNoTipPeaking"),
      });
      return;
    }
    if (val == 0) {
      //固定
      this.columns = this.columnlist; //正常列信息
      this.addfiexd(null);
      this.pricepo.cycle = 0;
      this.isAble = true; //周期是否可用
    } else if (val == 1) {
      //尖峰平谷
      this.addPeakPinggu(null);
      this.columns = this.columnlist;
      this.pricepo.cycle = 0;
      this.isAble = true; //周期是否可用
    } else {
      //阶梯价格
      this.addstepprice(null);
      this.columns = this.stepcolumnlist;
      this.pricepo.cycle = 1;
      this.isAble = false;
    }
  }
  create() { }
  save() {
    (this.$refs.priceForm as any).validate(async (valid: boolean) => {
      if (this.pricepo.priceType == 2) {
        if (
          this.pricepo.firstNum == 0 ||
          this.pricepo.secondNum == 0 ||
          this.pricepo.thirdNum == 0 ||
          this.pricepo.fourNum == 0
        ) {
          this.$Modal.info({
            title: this.L("Tips"),
            content: this.L("StepNumNoEmpty"),
          });
          return;
        }
        if (this.pricepo.firstNum > this.pricepo.secondNum) {
          this.$Modal.info({
            title: this.L("Tips"),
            content: this.L("FirstMaxSecond"),
          });
          return;
        }
        if (this.pricepo.secondNum > this.pricepo.thirdNum) {
          this.$Modal.info({
            title: this.L("Tips"),
            content: this.L("SecondMaxThird"),
          });
          return;
        }
        if (this.pricepo.thirdNum > this.pricepo.fourNum) {
          this.$Modal.info({
            title: this.L("Tips"),
            content: this.L("ThirdMaxFour"),
          });
          return;
        }
      }
      if (this.pricepo.summerFirstPrice > 0) {
        this.pricepo.isSummer = true;
      } else {
        this.pricepo.isSummer = false;
      }
      if (valid) {
        await this.$store
          .dispatch({
            type: "price/create",
            data: this.pricepo,
          })
          .catch((err) => {
            this.$Modal.info({
              title: this.L("Tips"),
              content: err,
            });
          });
        (this.$refs.priceForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.priceForm as any).resetFields();
    this.$emit("input", false);
  }
  meterTypeDetail() {
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      detaillist.forEach((ele) => {
        if (ele.itemId == 7) {
          this.$data.meterTypedetail.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 8) {
          this.$data.useTypedetail.push({ label: ele.name, value: ele.id });
        }
      });
    }
  }
  async areaTree() {
    await this.$store
      .dispatch("area/getAreaSelectTree")
      .then((val) => {
        this.$data.optionsMechanism = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  ruleValidate = {
    name: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    areaId: [
      {
        type: "number",
        required: true,
        message: this.L("Areas") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    meterType: [
      {
        type: "number",
        required: true,
        message: this.L("Category") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    priceType: [
      {
        type: "number",
        required: true,
        message: this.L("Category") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    basePrice: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    settlementStandard: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    cycle: [
      {
        type: "number",
        message: this.L("Cycle") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    unitname: [
      {
        message: this.L("Category") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    unitnum: [
      {
        message: this.L("Unit") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    firstnum: [
      {
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    firstBasePrices: [
      {
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    firstsewage: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    firstsynthetical: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    secondnum: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    secondbase: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    secondsewage: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    secondsynthetical: [
      {
        message: this.L("Category") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    thirdnum: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    thirdbase: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    thirdsewage: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    thirdsynthetical: [
      {
        message: this.L("Category") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    fournum: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    fourbase: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    foursewage: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    foursynthetical: [
      {
        message: this.L("Category") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    sortCode: [
      {
        message: this.L("Category") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  data() {
    return {
      optionsMechanism: [],
      meterTypedetail: [],
      useTypedetail: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
